module.exports = __webpack_public_path__ + "img/other.af08942c.png";